let _ = t => t,
  _t;
import { match } from 'ts-pattern';
import styled from 'styled-components';
import Button from '../Button';
export const StyledButton = styled(Button)(_t || (_t = _`
    min-width: ${0};
    max-width: initial;
    max-height: initial;

    padding: 6px;
`), ({
  size
}) => match(size).with('sm', () => '36px').with('md', () => '40px').run());